import React from "react";
import { CreateInsuranceFields } from "../../types";
import { Box, TextField } from "@mui/material";
import { CURRENCY, KIND_OF_INSURANCE } from "@pages/shippingView/config";
import AutocompleteElement from "@atoms/autocomplete";

interface Props {
  fields: Partial<CreateInsuranceFields>;
  updateFields: (updated: Partial<CreateInsuranceFields>) => void;
}

const CreateInsurance: React.FC<Props> = ({ fields, updateFields }) => {
  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        gap: 2,
        display: "grid",
        gridAutoFlow: "row",
        justifyContent: "start",
        gridTemplateColumns: "repeat(3, 360px)",
      }}
    >
      <TextField
        label="Application number"
        value={fields?.application_id || ""}
        sx={{ maxWidth: "360px" }}
        onChange={(e: any) =>
          updateFields({ application_id: e.target.value ?? null })
        }
      />
      <TextField
        label="Insurance number"
        value={fields?.insurance_policy_number || ""}
        sx={{ maxWidth: "360px" }}
        onChange={(e: any) =>
          updateFields({
            insurance_policy_number: e.target.value ?? null,
          })
        }
      />
      <AutocompleteElement
        options={KIND_OF_INSURANCE}
        multi={false}
        label="Kind of insurance"
        value={fields?.insurance_type || null}
        onChange={(_: any, value: string | null) =>
          updateFields({
            insurance_type: value ?? null,
          })
        }
        sx={{ maxWidth: "360px" }}
      />
      <TextField
        label="Insurance company"
        value={fields?.insurer_name || ""}
        sx={{ maxWidth: "360px" }}
        onChange={(e: any) =>
          updateFields({
            insurer_name: e.target.value ?? null,
          })
        }
      />
      <TextField
        label="Insurance premium"
        type="number"
        value={fields?.premium_amount || ""}
        sx={{ maxWidth: "360px" }}
        onChange={(e: any) =>
          updateFields({
            premium_amount: e.target.value ?? null,
          })
        }
      />
      <AutocompleteElement
        options={CURRENCY}
        multi={false}
        label="Currency"
        value={fields?.currency || null}
        onChange={(_: any, value: string | null) =>
          updateFields({
            currency: value ?? null,
          })
        }
        sx={{ maxWidth: "360px" }}
      />
      <TextField
        label="Name of  Marine Surveyor in case of damage"
        value={fields?.damage_surveyor || ""}
        sx={{ maxWidth: "360px" }}
        onChange={(e: any) =>
          updateFields({
            damage_surveyor: e.target.value ?? null,
          })
        }
      />
    </Box>
  );
};

export default CreateInsurance;
